import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { ChevronIcon, MoreIcon } from '@chegg-ui/theme';
import { clickBaseEvent } from '@chegg-me-components/utils';
import { rioClient } from '../../../shared/rio';
import { DropdownUL, NavDropdownLink, CaretButton, BorderedAvatar, UserDropdownInfoLink, UserDropdownTextContainer, UserName, UserEmail, ThreeDots, DropdownLI, PaddedAvatar, DesktopUserMenuContainer } from '../../../styles';
import { UserDropdownInfo, BlackStyledToggletip } from '../../../styles.retrofit';

var DesktopUserMenu = function DesktopUserMenu(_ref) {
  var user = _ref.user,
      envUrl = _ref.envUrl,
      userLinks = _ref.userLinks;
  // TODO infra: memoize links? https://chegg.atlassian.net/browse/CUI-368
  var dropdownLinkComponents = userLinks.map(function (linkDetails, index) {
    return /*#__PURE__*/React.createElement(DropdownLI, {
      key: linkDetails.text
    }, /*#__PURE__*/React.createElement(NavDropdownLink, {
      href: "".concat(envUrl).concat(linkDetails.href),
      "data-test": "header-desktop-user-menu-link-".concat(index),
      onClick: function onClick(e) {
        var _linkDetails$onClick;

        var text = linkDetails.text;
        var value = text.toLowerCase();
        rioClient.sendEvent(_objectSpread(_objectSpread({}, clickBaseEvent), {}, {
          data: {
            interaction: {
              type: 'select',
              element: {
                text: text,
                value: value,
                type: 'link',
                name: 'profile options',
                region_name: 'top nav'
              }
            }
          }
        }));
        (_linkDetails$onClick = linkDetails.onClick) === null || _linkDetails$onClick === void 0 ? void 0 : _linkDetails$onClick.call(linkDetails, e);
      }
    }, /*#__PURE__*/React.createElement("span", null, linkDetails.text)));
  });
  return /*#__PURE__*/React.createElement(DesktopUserMenuContainer, null, user && /*#__PURE__*/React.createElement(BlackStyledToggletip, {
    position: "bottomLeft",
    targetElement: /*#__PURE__*/React.createElement(CaretButton, {
      onClick: function onClick() {
        rioClient.sendEvent(_objectSpread(_objectSpread({}, clickBaseEvent), {}, {
          data: {
            interaction: {
              type: 'expand',
              element: {
                type: 'drop down',
                name: 'nav user shortcut',
                region_name: 'nav header'
              }
            }
          }
        }));
      },
      "data-test": "header-desktop-user-menu-icon",
      screenReaderOnlyText: "account"
    }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BorderedAvatar, {
      size: 'small',
      name: user.fname,
      image: {
        src: user.avatar,
        alt: ''
      }
    }), /*#__PURE__*/React.createElement(ChevronIcon, {
      size: "xsmall"
    })))
  }, /*#__PURE__*/React.createElement(DropdownUL, {
    "data-test": "header-desktop-user-menu-list"
  }, /*#__PURE__*/React.createElement(UserDropdownInfo, null, /*#__PURE__*/React.createElement(UserDropdownInfoLink, {
    href: "".concat(envUrl, "my/profile"),
    "data-test": "header-desktop-user-menu-info"
  }, /*#__PURE__*/React.createElement(PaddedAvatar, {
    size: 'medium',
    name: user.fname,
    image: {
      src: user.avatar,
      alt: ''
    },
    onClick: function onClick() {
      rioClient.sendEvent(_objectSpread(_objectSpread({}, clickBaseEvent), {}, {
        data: {
          interaction: {
            type: 'expand',
            element: {
              type: 'icon',
              name: 'profile image',
              region_name: 'top nav'
            }
          }
        }
      }));
    }
  }), /*#__PURE__*/React.createElement(UserDropdownTextContainer, null, /*#__PURE__*/React.createElement(UserName, {
    "data-test": "header-desktop-user-menu-username"
  }, user.fname, " ", user.lname), /*#__PURE__*/React.createElement(UserEmail, {
    "data-test": "header-desktop-user-menu-email"
  }, user.emailShow), /*#__PURE__*/React.createElement(ThreeDots, null, /*#__PURE__*/React.createElement(MoreIcon, {
    size: "xsmall"
  }))))), dropdownLinkComponents)));
};

DesktopUserMenu.displayName = 'DesktopUserMenu';
export default DesktopUserMenu;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-me-components/header/dist/esm/shared/retrofit/desktop/DesktopUserMenu.js
// module id = 5622
// module chunks = 11